var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgInfoIcon = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M262.114,181.531a1.659,1.659,0,0,1-1.658,1.658H213.022a1.66,1.66,0,0,1-1.658-1.658V159.54l20.692,14.886c.058.04.116.078.176.112a7.927,7.927,0,0,0,9.015,0c.06-.034.12-.072.176-.112l20.691-14.886ZM216.8,152.525v6.46l-4.252-3.058Zm3.625-19.745a.345.345,0,0,1,.341-.341h31.945a.345.345,0,0,1,.339.341v28.813l-13.659,9.827c-2.162,1.191-3.143,1.191-5.307,0l-13.659-9.827Zm36.25,19.745,4.254,3.4-4.254,3.058Zm9.024,3.286a1.644,1.644,0,0,0-.225-.694,1.823,1.823,0,0,0-.078-.172c-.029-.04-.072-.06-.1-.1a1.863,1.863,0,0,0-.254-.239l.018-.022-8.383-6.7v-15.1a3.97,3.97,0,0,0-3.964-3.966H220.767a3.971,3.971,0,0,0-3.966,3.966v15.1l-8.381,6.7.016.022a1.882,1.882,0,0,0-.254.241c-.031.036-.074.056-.1.1a1.484,1.484,0,0,0-.08.172,1.644,1.644,0,0,0-.225.694,1.765,1.765,0,0,0-.038.19v25.529a5.289,5.289,0,0,0,5.283,5.283h47.433a5.288,5.288,0,0,0,5.283-5.283V156a1.772,1.772,0,0,0-.038-.19",
    transform: "translate(-207.739 -128.814)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInfoIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/info-icon.f8e82ac9.svg";
export { ForwardRef as ReactComponent };